// src/api/mock/speakerData.js
const baseData = [
  { name: "User1", title: "Technology Consultant", degree: "S.Kom.", topic: "Cloud Architecture & .NET 10" },
  { name: "User2", title: "Infrastructure Engineer", degree: "B.Tech", topic: "DevOps & Kubernetes" },
  { name: "User3", title: "Senior Lead Developer", degree: "M.Sc.", topic: "Microservices Integration" },
  { name: "User4", title: "Database Architect", degree: "B.E.", topic: "Oracle Optimization" },
  { name: "User5", title: "Backend Specialist", degree: "M.Tech", topic: "SCIM & Auth Systems" },
  { name: "User6", title: "Cloud Observability Lead", degree: "Ph.D.", topic: "OpenTelemetry & Metrics" }
];

export const speakerMockData = Array.from({ length: 90 }, (_, index) => {
  const base = baseData[index % baseData.length];
  
  return {
    id: index + 1,
    name: `${base.name} ${index + 1}`,
    title: base.title,
    degree: base.degree,
    image: `https://i.pravatar.cc/400?u=${index}`,
    topic: base.topic
  };
});